import { z } from 'zod';
import { AdminRoleSchema } from './roles';

/* GET /api/admin/moderators (superadmin) */
export const ModeratorSchema = z.object({
  id: z.string(),
  email: z.string(),
  handle: z.string().nullable(),
  role: AdminRoleSchema,
  actionCount30d: z.number().int().nonnegative(),
  lastActionAt: z.iso.datetime().nullable(),
});
export type Moderator = z.infer<typeof ModeratorSchema>;

export const ModeratorsResponseSchema = z.object({ moderators: z.array(ModeratorSchema) });
export type ModeratorsResponse = z.infer<typeof ModeratorsResponseSchema>;

/* POST /api/admin/moderators — grant (role set) or revoke (role null). */
export const SetModeratorSchema = z.object({
  email: z.string().email().max(200),
  role: AdminRoleSchema.nullable(),
});
export type SetModerator = z.infer<typeof SetModeratorSchema>;
